<template lang="pug">
  .main(style="height: 100vh")
    el-row(style="height: 100vh")
      el-col.menu__container(:span="isMenuCollapsed ? 1 : 4")
        .menu__block
          el-menu.el-menu-vertical-demo.menu__list(:default-active="lastMenuIndex" :collapse="isMenuCollapsed" :collapse-transition="false")
            .menu-width-handler__container(@click="handleFullMenuStatus" :class="{ collapsed: isMenuCollapsed }")
              i.el-icon-caret-right(v-if="isMenuCollapsed")
              i.el-icon-caret-left(v-else)
            .menu__item(v-for="(menu, key) in availableMenus" :key="`menu-${menu.name}`")
              el-submenu(v-if="menu.isSubMenu" :index="`${key}`")
                  template(slot="title")
                      i(:class="menu.icon")
                      span(:class="{ hidden: isMenuCollapsed }") {{ menu.title }}
                  router-link(
                      v-for="(submenu, submenuKey) in menu.menuList"
                      :key="`menu-${menu.name}-submenu-${submenu.name}`"
                      :to="{name: submenu.name}"
                      v-if="submenu.access.includes(role)"
                      tag="div"
                  )
                      el-menu-item(:index="`${key}-${submenuKey}`" @click="saveLastMenuIndex(`${key}-${submenuKey}`)") {{ submenu.title }}
              router-link(
                  v-else
                  :to="{name: menu.name}"
                  tag="div"
              )
                  el-menu-item(:index="`${key}`" @click="saveLastMenuIndex(`${key}`)")
                      i(:class="menu.icon")
                      span(slot="title") {{ menu.title }}
            el-menu-item(:index="`${logoutIndex}`" @click="logout")
              i.el-icon-switch-button
              span Выйти
      el-col(:span="isMenuCollapsed ? 23 : 20" style="height: 100vh")
        .exchange-info__container
          .exchange-info-data__container(v-if="exchangeInfo.name")
            .exchange-info-name.exchange-info-status__ps
              span {{ exchangeInfo.name }}
              .exchange-info-status(:class="exchangeInfo.online ? 'background-success' : 'background-danger'")
            .exchange-info-status__container
              .exchange-info-status__ps
                span.exchange-info-status__title Карты
                .exchange-info-status(:class="exchangeInfo.active ? 'background-success' : 'background-danger'")
              .exchange-info-status__ps
                span.exchange-info-status__title СБП
                .exchange-info-status(:class="exchangeInfo.activeSbp ? 'background-success' : 'background-danger'")
              .exchange-info-status__ps
                span.exchange-info-status__title СНГ СБП
                .exchange-info-status(:class="exchangeInfo.activeForeignSbp ? 'background-success' : 'background-danger'")
              .exchange-info-status__ps
                span.exchange-info-status__title Сим-карты
                .exchange-info-status(:class="exchangeInfo.activeSim ? 'background-success' : 'background-danger'")
              .exchange-info-status__ps
                span.exchange-info-status__title QR
                .exchange-info-status(:class="exchangeInfo.activeQR ? 'background-success' : 'background-danger'")
          .exchange-info-wallet(v-if="exchangeInfo.wallet" @click="copyTextToClipboard(exchangeInfo.wallet)") {{ exchangeInfo.wallet }}
          .flex__spacer
          .exchange-info-balance__container(v-if="exchangeInfo.rate.value")
            .exchange-info-balance__val
              span Курс
              span.ml5(v-if="exchangeInfo.rate.source") {{ `${exchangeInfo.rate.source}` }}
              span.mr5 :
              span {{ exchangeInfo.rate.value }}
            .exchange-info-balance__val
              span.mr5 От:
              span {{ exchangeInfo.rate.updated }}
          .exchange-info-balance__container.left-wrapper(v-if="exchangeInfo.rate_exchange.value")
            .exchange-info-balance__val
              span Курс площадки:
              span {{ exchangeInfo.rate_exchange.value }}
            .exchange-info-balance__val
              span.mr5 От:
              span {{ exchangeInfo.rate_exchange.updated }}
          .exchange-info-balance__container.left-wrapper
            .exchange-info-balance__val
              span.mr5 Баланс:
              span {{ exchangeInfo.balance }} BTC
            .exchange-info-balance__val
              span.mr5 Обновлен:
              span {{ exchangeInfo.balanceUpdated }}
        router-view
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { CHANGE_RELOAD_STATUS } from '../../store/const/index';
import { AUTH_LOGOUT } from '../../store/const/user';
import { LOAD_USER_BALANCE} from "../../store/const/settings";
import { LOAD_EXCHANGE_INFO } from "../../store/const/exchange";
import instruments from '../../mixins/instruments';
import ExchangePicker from "./ExchangePicker";

export default {
  name: "Index",
  components: {
    ExchangePicker,
  },
  mixins: [
    instruments,
  ],
  data() {
    return {
      menuList: [
        {
          name: 'OrdersList',
          title: 'Заявки',
          icon: 'el-icon-s-grid',
          access: ['superadmin', 'admin', 'support', 'partner']
        },
        {
          name: 'ClaimsList',
          title: 'Претензии',
          icon: 'el-icon-s-release',
          access: ['superadmin', 'admin', 'support']
        },
        {
          name: 'ExchangeStats',
          title: 'Статистика',
          icon: 'el-icon-coin',
          access: ['superadmin', 'partner']
        },
        {
          name: 'Finished',
          title: 'Завершенные',
          icon: 'el-icon-finished',
          access: ['superadmin']
        },
        {
          name: 'UsersList',
          title: 'Пользователи',
          icon: 'el-icon-user',
          access: ['superadmin']
        },
        {
          name: 'Settings',
          title: 'Глобальные настройки',
          icon: 'el-icon-setting',
          isSubMenu: true,
          access: ['superadmin'],
          menuList: [
            {
              name: 'Settings',
              title: 'Общие настройки',
              access: ['superadmin']
            },
            {
              name: 'DeeplinkAndQr',
              title: 'Deeplink/QR',
              access: ['superadmin']
            },
          ],
        },
        {
          name: 'ExchangeSettings',
          title: 'Настройки обменки',
          icon: 'el-icon-set-up',
          isSubMenu: true,
          access: ['superadmin'],
          menuList: [
            {
              name: 'ExchangeSettings',
              title: 'Направления',
              access: ['superadmin']
            },
            {
              name: 'InterBanks',
              title: 'Внутребанк',
              access: ['superadmin']
            },
          ]
        },
        {
          name: 'BlackList',
          title: 'Черный список',
          icon: 'el-icon-user-solid',
          isSubMenu: true,
          access: ['superadmin', 'admin', 'support'],
          menuList: [
            {
              name: 'BlackListUsers',
              title: 'Клиенты',
              access: ['superadmin', 'admin', 'support'],
            },
            {
              name: 'BlackListRequisites',
              title: 'Реквизиты',
              access: ['superadmin', 'admin', 'support']
            },
          ]
        },
        {
          name: 'Administration',
          title: 'Администрирование',
          icon: 'el-icon-s-data',
          isSubMenu: true,
          access: ['superadmin', 'admin'],
          menuList: [
            {
              name: 'Service',
              title: 'Сервис',
              access: ['superadmin', 'admin']
            },
            {
              name: 'ActionsStats',
              title: 'Мониторинг активности',
              access: ['superadmin', 'admin']
            },
          ]
        },
      ],
      intervalHandle: null,
      isMenuCollapsed: false,
      lastMenuIndex: localStorage.getItem('menu_index') || '0',
    }
  },
  watch: {
    reload(reload) {
      if (reload) {
        this.changeReloadStatus({ status: false });
        this.$router.go();
      }
    },
  },
  async mounted() {
    await this.loadUserBalance();
    await this.loadExchangeInfo();
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalHandle);
  },
  computed: {
    ...mapGetters('user', {
      role: 'getRole',
      isAdmin: 'isAdmin',
    }),
    ...mapGetters('settings', ['userBalance']),
    ...mapGetters('exchange', ['exchangeInfo']),
    ...mapGetters(['reload']),
    availableMenus() {
      return this.menuList.filter((menu) => menu.access.includes(this.role));
    },
    logoutIndex() {
      return this.availableMenus.length;
    }
  },
  methods: {
    ...mapActions({
      changeReloadStatus: CHANGE_RELOAD_STATUS,
    }),
    ...mapActions('user', {
      logoutRequest: AUTH_LOGOUT,
    }),
    ...mapActions('settings', {
      loadUserBalance: LOAD_USER_BALANCE,
    }),
    ...mapActions('exchange', {
      loadExchangeInfo: LOAD_EXCHANGE_INFO,
    }),
    async logout() {
      await this.logoutRequest();
    },
    startInterval() {
      this.intervalHandle = setInterval(() => {
        this.loadUserBalance();
        this.loadExchangeInfo();
      }, 10000);
    },
    handleFullMenuStatus() {
      this.isMenuCollapsed = !this.isMenuCollapsed;
    },
    saveLastMenuIndex(index) {
      localStorage.setItem('menu_index', index);
    },
  }
}
</script>

<style lang="scss">
.main {
  text-align: left;
}

.menu__list {
  height: 100%;
}

.mode-select__container {
  padding: 10px 0;
  margin: auto;
  text-align: center;
  border-bottom: 1px solid #e6e6e6;
}

.mode-select__container .title {
  font-weight: 500;
  margin-bottom: 5px;
}

.module__main {
  overflow-y: hidden;
  height: calc(100% - 50px);
  display: flex;
  flex-direction: column;
}

.module__title {
  font-size: 20px;
  height: 29px;
  padding: 5px 10px;
  background-color: #efefef;
  text-shadow: 1px 1px 1px #cce0f1;
  color: #05447a;
  font-weight: bold;
  text-align: center;
}

.module-content__container {
  display: flex;
  flex-direction: column;
  padding: 5px;
  background-color: #e3e0e0;
  border-left: 1px solid #d1cece;
  border-top: 1px solid #d1cece;
  overflow-y: hidden;
  height: 100%;
}

.menu__container {
  display: flex;
  height: 100vh;
  flex-direction: column;
  background-color: #efefef;
  padding: 4px;
}

.menu__block {
  height: 100%;
}

.menu-width-handler__container {
  cursor: pointer;
  width: 100%;
  text-align: right;
}

.menu-width-handler__container.collapsed {
  text-align: center;
}

.menu-width-handler__container:hover {
  background-color: #f7f7f7;
}

.table__container {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}

.table-list__container {
  overflow-y: scroll;
  border-radius: 5px;
}

.table-pagination__container {
  margin-bottom: 5px;
  text-align: center;
}

.table-list__container .val {
  text-overflow: ellipsis;
  word-break: break-word;
}

.dialog-add__input {
  width: 100%;
  margin: 5px auto;
}

.color-success {
  color: #67C23A;
}

.background-success {
  background-color: #67C23A;
}

.color-warning {
  color: #E6A23C;
}

.background-warning {
  background-color: #E6A23C;
}

.color-danger {
  color: #F56C6C;
}

.background-danger {
  background-color: #F56C6C;
}

.color-info {
  color: #909399;
}

.background-info {
  background-color: #909399;
}

.color-primary {
  color: #909399;
}

.background-primary {
  background-color: #409EFF;
}

tr.row-success {
  background-color: #c4f8ae !important;
}

tr.row-danger {
  background-color: #fcbbbb !important;
}

.balance__container {
  display: flex;
  align-items: center;
  padding: 8px;
  background-color: #efefef;
  font-size: 12px
}

.balance-amounts__container {
  margin: auto 10px;
}

.balance-amount__container {
  display: flex;
}

.balance__icon {
  color: green;
  font-size: 16px;
}

.balance__title {
  margin-right: 5px;
  width: 60px;
}

.exchange-info__container {
  background-color: #efefef;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  height: 40px;
}

.exchange-info-status__container {
  display: flex;
  font-size: 10px;
}

.exchange-info-status {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin: auto 4px;
}

.exchange-info-status__ps {
  display: flex;
  margin: 0 4px;
}

.exchange-info-name {
  margin-bottom: 5px;
  font-weight: bold;
}

.exchange-info-wallet {
  margin-left: 10px;
  font-family: monospace;
  cursor: pointer;
}

.menu__block a {
  text-decoration: none;
}

.exchange-select__container {
  width: 250px;
  margin-right: 10px;
}

.exchange-select {
  width: 100%;
  margin: auto 5px;
}

.exchange-info-data__container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border: 1px solid #b9b9b9;
  background-color: #ffffff;
}

.exchange-info-balance__container {
  margin: auto 10px;
  font-family: monospace;
}

.flex__spacer {
  flex-grow: 1;
}

.left-wrapper {
  padding-left: 10px;
  border-left: 1px solid #d1cece;
}

.mr5 {
  margin-right: 5px;
}

.ml5 {
  margin-left: 5px;
}

.mt5 {
  margin-top: 5px;
}

.mb5 {
  margin-bottom: 5px;
}

.mr10 {
  margin-right: 10px;
}

.ml10 {
  margin-left: 10px;
}

.mt10 {
  margin-top: 10px;
}

.mb10 {
  margin-bottom: 10px;
}

.hidden {
  display: none;
}

.dialog__container {
  padding: 6px;
  background-color: #f1f1f1;
  border: 1px solid #e5dddd;
  border-radius: 4px;
}

.dialog-input__block {
  padding: 4px;
  margin-bottom: 4px;
  border-bottom: 1px solid #e3e3e3;
}

.dialog-input__title {
  font-weight: 500;
  padding: 1px;
  margin-bottom: 3px;
}

.dialog__buttons {
  margin-top: 4px;
  padding-top: 8px;
  border-top: 1px solid #97999f;
}

.dialog-input__required {
  padding: 1px;
  color: red;
  font-weight: bold;
}

.dialog-input__required::after {
  content: "*";
}

.flex-centered {
  display: flex;
  justify-content: center;
  align-items: center;
}

.cursor-pointer {
  cursor: pointer;
}
</style>

